import { Calendar, Clock, MapPin } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useLanguage } from "@/contexts/LanguageContext";
import { useSiteContent } from "@/hooks/useSiteContent";

const Services = () => {
  const { t } = useLanguage();
  const { content } = useSiteContent('services');
  
  return (
    <section id="services" className="py-20 bg-surface">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
            {content.title || t("services.title")}
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
            {content.subtitle || t("services.subtitle")}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto mb-12">
          <Card className="border-2 hover:shadow-xl transition-shadow">
            <CardContent className="p-8">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-primary mb-2">{t("services.sunday")}</h3>
                <div className="w-20 h-1 bg-accent mx-auto rounded-full" />
              </div>
              <div className="space-y-4">
                <div className="flex items-center gap-3 text-lg">
                  <Clock className="w-6 h-6 text-primary flex-shrink-0" />
                  <span>{t("services.sunday.time")}</span>
                </div>
                <p className="text-muted-foreground whitespace-pre-line">{t("services.sunday.desc")}</p>
              </div>
            </CardContent>
          </Card>

          <Card className="border-2 hover:shadow-xl transition-shadow">
            <CardContent className="p-8">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-primary mb-2">{t("services.bible")}</h3>
                <div className="w-20 h-1 bg-accent mx-auto rounded-full" />
              </div>
              <div className="space-y-4">
                <div className="flex items-center gap-3 text-lg">
                  <Clock className="w-6 h-6 text-primary flex-shrink-0" />
                  <span>{t("services.bible.time")}</span>
                </div>
                <p className="text-muted-foreground whitespace-pre-line">{t("services.bible.desc")}</p>
              </div>
            </CardContent>
          </Card>

          <Card className="border-2 hover:shadow-xl transition-shadow">
            <CardContent className="p-8">
              <div className="text-center mb-6">
                <h3 className="text-2xl font-bold text-primary mb-2">{t("services.prayer")}</h3>
                <div className="w-20 h-1 bg-accent mx-auto rounded-full" />
              </div>
              <div className="space-y-4">
                <div className="flex items-center gap-3 text-lg">
                  <Clock className="w-6 h-6 text-primary flex-shrink-0" />
                  <span>{t("services.prayer.time")}</span>
                </div>
                <p className="text-muted-foreground whitespace-pre-line">{t("services.prayer.desc")}</p>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="text-center">
          <div className="inline-flex items-center gap-2 text-lg text-muted-foreground">
            <MapPin className="w-5 h-5 text-primary" />
            <span>{content.address || t("services.address")}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
